// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__0kFrj","topSection":"Footer_topSection__Rf2yg","rightSection":"Footer_rightSection__qcqaG","footerButton":"Footer_footerButton__xfMFy"};